// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".videoContainer-3XYyNrsH {\n    position: relative;\n    overflow: hidden;\n}\n\n.containerMargin-3dikTDrF {\n    width: unset !important;\n    margin: 0 26px;\n}\n", ""]);
// Exports
exports.locals = {
	"videoContainer": "videoContainer-3XYyNrsH",
	"containerMargin": "containerMargin-3dikTDrF"
};
module.exports = exports;
